<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-input-group nzSearch
    [nzAddOnAfter]="recordProperty.ReadOnly || moduleStructure.module.AdditionalInformationParsed.InventoryDirection === ModuleInventoryDirection.None ? undefined : suffixButton">
    <nz-input-number
    [class]="parentClass"
     [nzFormatter]="formatterQuantity" [nzParser]="numberParser"
      [name]="sectionTagName+'.' +field.FieldName" [(ngModel)]="recordProperty.ValueAsObject"
      [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged()" [nzDisabled]="recordProperty.ReadOnly"
      [nzMax]="recordProperty.MaxValue" [nzMin]="recordProperty.MinValue" nz-tooltip
      [class]="parentClass"
      [nzTooltipTitle]="recordProperty.MinValue !== undefined || recordProperty.MaxValue !== undefined ? tooltip : undefined">
    </nz-input-number>
    <ng-template #tooltip>
      <span *ngIf="recordProperty.MinValue !== undefined">
        {{'Min. ' | locale}} {{recordProperty.MinValue}}
      </span>
      <span *ngIf="recordProperty.MaxValue !== undefined">
        <nz-divider *ngIf="recordProperty.MinValue !== undefined"></nz-divider>
        {{'Max. ' | locale}} {{recordProperty.MaxValue}}
      </span>
    </ng-template>
  </nz-input-group>
  <ng-template #suffixButton>
    <button nz-button nzType="primary" nzSearch (click)="makeDrawerVisible();" [disabled]="recordProperty.ReadOnly">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
    </button>
  </ng-template>
</nz-form-control>
<ng-container *ngIf="recordProperty.DialogVisibleDrawerInitialized">
  <nz-drawer [nzVisible]="recordProperty.DialogVisible" (nzVisibleChange)="drawerVisibleChange()"
    (nzOnClose)="drawerConfirm()" nzWrapClassName="drawer-size-3x"
    [nzTitle]="('Qty Details - Req. Qty' | locale) + ': ' + formatterQuantity(openQuantityProperty.ValueAsObject)"
    [nzFooter]="drawerFooter">
    <nz-space nzDirection="vertical" style="width: 100%;" *ngIf="recordProperty.DialogVisible">
      <nz-space-item>
        <nz-descriptions [nzSize]="'small'" [nzBordered]="true"
          [nzColumn]="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }">
          <nz-descriptions-item [nzTitle]="'Item' | locale">
            {{itemCode}} - {{itemDescription}}
          </nz-descriptions-item>
          <nz-descriptions-item [nzTitle]="'Req. Qty' | locale">
            {{formatterQuantity(openQuantityProperty.ValueAsObject)}}
          </nz-descriptions-item>
          <nz-descriptions-item [nzTitle]="'Req. Serial' | locale" *ngIf="manSerNum">
            {{(unitsOfMeasurmentProperty == undefined || unitsOfMeasurmentProperty.ValueAsObject == 0) ?
            openQuantityProperty.ValueAsObject :
            openQuantityProperty.ValueAsObject * unitsOfMeasurmentProperty.ValueAsObject}}
          </nz-descriptions-item>
          <nz-descriptions-item [nzTitle]="'Selected Qty' | locale" nzSpan="1">
            <span>{{formatSelectedQuantity()}}</span>
          </nz-descriptions-item>
        </nz-descriptions>
      </nz-space-item>
      <nz-space-item
        *ngIf="moduleStructure.module.AdditionalInformationParsed.InventoryDirection === ModuleInventoryDirection.Inbound">
        <ng-container *ngIf="manSerNum">
          <app-inbound-serial [(serialNumbers)]="serialNumbers" [binLocations]="binLocations"
            [moduleStructure]="moduleStructure" [binActivated]="binActivated"
            [requiredQty]="openQuantityProperty.ValueAsObject" [wareHouseCode]="warehouseCode"
            [requiredSerialQty]="(unitsOfMeasurmentProperty == undefined || unitsOfMeasurmentProperty.ValueAsObject == 0) ? openQuantityProperty.ValueAsObject : openQuantityProperty.ValueAsObject * unitsOfMeasurmentProperty.ValueAsObject"
            [(selectedSSCC)]="selectedSSCC" [unitsOfMeasurmentProperty]="unitsOfMeasurmentProperty"
            [qtyProperty]="recordProperty" [(selectedQty)]="selectedQty">
          </app-inbound-serial>
        </ng-container>
        <ng-container *ngIf="manBtchNum">
          <app-inbound-batch [(batchNumbers)]="batchNumbers" [(selectedQty)]="selectedQty" [binActivated]="binActivated"
            [binLocations]="binLocations" [(selectedSSCC)]="selectedSSCC" [qtyProperty]="recordProperty"
            [unitsOfMeasurmentProperty]="unitsOfMeasurmentProperty" [selectedBinLocation]="selectedBinLocation"
            [requiredQty]="openQuantityProperty.ValueAsObject" [itemCode]="itemCode" [moduleStructure]="moduleStructure"
            [recordModel]="recordModel" [recordLine]="recordLine">
          </app-inbound-batch>
        </ng-container>
        <ng-container *ngIf="binActivated && !manSerNum && !manBtchNum">
          <app-inbound-bin [(binLocationData)]="binLocationData" [requiredQty]="recordProperty.ValueAsObject"
            [(selectedQty)]="selectedQty">
          </app-inbound-bin>
        </ng-container>
      </nz-space-item>
      <nz-space-item
        *ngIf="moduleStructure.module.AdditionalInformationParsed.InventoryDirection === ModuleInventoryDirection.Outbound">
        <ng-container *ngIf="binActivated && !manSerNum">
          <nz-table #table [nzData]="listOfDisplayData">
            <thead>
              <tr>
                <th>
                  {{'Bin Location' | locale}}
                </th>
                <th *ngIf="manBtchNum">
                  {{'Batch Number' | locale}}
                </th>
                <th *ngIf="manBtchNum && global.displayExpirationDateForBinBatchs">
                  {{'Expiration date' | locale}}
                </th>
                <th style="min-width: 125px;">
                  {{'Quantity' | locale}}
                </th>
              </tr>
              <tr>
                <th>
                  <input nz-input [(ngModel)]="binSearchValue" [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="updateFilter()
                " [nzSize]="'small'" />
                </th>
                <th>
                  <input nz-input [(ngModel)]="distSearchValue" [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="updateFilter()
                " [nzSize]="'small'" />
                </th>
                <th *ngIf="manBtchNum && global.displayExpirationDateForBinBatchs"></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let bin of table.data">
                <td>
                  {{bin.BinCode}}
                </td>
                <td *ngIf="manBtchNum">
                  {{bin.DistNumber}}
                  <br />
                  {{'Qty:' | locale}} {{bin.OnHandQty}}
                </td>
                <td *ngIf="manBtchNum && global.displayExpirationDateForBinBatchs">
                  {{bin.ExpDate}}
                </td>
                <td>
                  <nz-input-group nzSearch="true" [nzAddOnAfter]="toBinActivated ? toBinButton : undefined">
                    <nz-input-number [(ngModel)]="bin.SelectedQuantity" [ngModelOptions]="{ updateOn: 'blur'}"
                      (ngModelChange)="binQuantitySelected();" style="width: 100%;"></nz-input-number>
                  </nz-input-group>
                  <nz-drawer [nzVisible]="bin.QtyDetailsDialog" (nzOnClose)="toBinConfirm(bin)"
                    [nzTitle]="'Receiver Bin Location Details' | locale" nzWrapClassName="drawer-size-3x"
                    [nzFooter]="drawerFooter">
                    <nz-descriptions [nzBordered]="true" [nzColumn]="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }">
                      <nz-descriptions-item [nzTitle]="'Batch Number' | locale" *ngIf="manBtchNum">
                        {{bin.DistNumber}}
                      </nz-descriptions-item>
                      <nz-descriptions-item [nzTitle]="'From Bin Location' | locale">
                        {{bin.BinCode}}
                      </nz-descriptions-item>
                      <nz-descriptions-item [nzTitle]="'Required Qty' | locale">
                        {{openQuantityProperty.ValueAsObject - selectedQty}}
                      </nz-descriptions-item>
                    </nz-descriptions>
                    <br />
                    <nz-table *ngIf="bin.QtyDetailsDialog" #binQtyDetailsDialogTable [nzData]="toBinLocationData">
                      <thead>
                        <tr>
                          <th>
                            {{'Bin Location' | locale}}
                          </th>
                          <th>
                            {{'Quantity' | locale}}
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <input nz-input [(ngModel)]="binInnerSearchValue" [ngModelOptions]="{ updateOn: 'blur'}"
                              (ngModelChange)="updateInnerFilter()
                          " [nzSize]="'small'" />
                          </th>
                          <th></th>
                        </tr>
                      </thead>
            <tbody>
              <tr *ngFor="let toBin of binQtyDetailsDialogTable.data">
                <td>{{toBin.BinCode}}</td>
                <td>
                  <nz-input-number [(ngModel)]="bin['To-' + toBin.AbsEntry]"
                    [nzDisabled]="toBin.BinCode === bin.BinCode">
                  </nz-input-number>
                </td>
              </tr>
            </tbody>
          </nz-table>
  </nz-drawer>
  <ng-template #drawerFooter>
    <button nz-button nzType="primary" (click)="toBinConfirm(bin)">{{'Ok' | locale }}</button>
  </ng-template>
  <ng-template #toBinButton>
    <button nz-button nzType="primary" nzSearch (click)="bin.QtyDetailsDialog = true;"
      [disabled]="recordProperty.ReadOnly">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
    </button>
  </ng-template>
  </td>
  </tr>
  </tbody>
  </nz-table>
</ng-container>
<ng-container *ngIf="manBtchNum && !binActivated">
  <app-outbound-batch [toBinActivated]="toBinActivated" [toBinLocations]="toBinLocations" [(selectedQty)]="selectedQty"
    [requiredQty]="openQuantityProperty.ValueAsObject" [moduleStructure]="moduleStructure"
    [qtyProperty]="recordProperty" [(batchNumbers)]="batchNumbers" [numPerSale]="numPerSale">
  </app-outbound-batch>
</ng-container>
<ng-container *ngIf="manSerNum">
  <app-outbound-serial [toBinActivated]="toBinActivated" [toBinLocations]="toBinLocations" [(selectedQty)]="selectedQty"
    [requiredQty]="openQuantityProperty.ValueAsObject" [moduleStructure]="moduleStructure"
    [(serialNumbers)]="serialNumbers" [qtyProperty]="recordProperty"
    [requiredSerialQty]="(unitsOfMeasurmentProperty == undefined || unitsOfMeasurmentProperty.ValueAsObject == 0) ? openQuantityProperty.ValueAsObject : openQuantityProperty.ValueAsObject * unitsOfMeasurmentProperty.ValueAsObject"
    [unitsOfMeasurmentProperty]="unitsOfMeasurmentProperty">
  </app-outbound-serial>
</ng-container>
</nz-space-item>
</nz-space>
</nz-drawer>
</ng-container>
<ng-template #drawerFooter>
  <button nz-button nzSize="large" nzType="primary" (click)="drawerConfirm()">
    {{'Ok' | locale}}
  </button>
</ng-template>
